/**
 * Backend-proxied OIDC endpoints.
 *
 * The browser must not call Keycloak discovery/token/revoke endpoints directly.
 * All Keycloak protocol calls are routed through MarchAgent backend `/api/v1/auth/*`.
 */

import { getMarchHttpApiBase } from '../api/marchApiEnv';

export type OidcConfiguration = {
  issuer?: string;
  authorization_endpoint?: string;
  token_endpoint: string;
  revocation_endpoint?: string;
  end_session_endpoint?: string;
  jwks_uri?: string;
};

let cachedConfig: OidcConfiguration | null = null;

function authUrl(path: string): string {
  const base = getMarchHttpApiBase().replace(/\/+$/, '');
  const cleanPath = path.replace(/^\/+/, '');
  return `${base}/api/v1/auth/${cleanPath}`;
}

function backendConfiguration(): OidcConfiguration {
  return {
    issuer: 'marchagent-backend',
    authorization_endpoint: authUrl('authorize'),
    token_endpoint: authUrl('token'),
    revocation_endpoint: authUrl('revoke'),
    end_session_endpoint: authUrl('logout'),
  };
}

/** Return backend-proxied OIDC endpoints. Never fetch Keycloak from the browser. */
export async function getOidcConfiguration(): Promise<OidcConfiguration | null> {
  if (cachedConfig) return cachedConfig;
  cachedConfig = backendConfiguration();
  return cachedConfig;
}

/** Reset cached discovery (tests). */
export function clearOidcConfigurationCache(): void {
  cachedConfig = null;
}
